"use strict";
/**
 * author: Qian.qianchen 2019-01-16
 * description: 自定义舆情
 */
angular.module('customSentimentModule', ['emphasisSentimentModule', 'customDetailModule', 'mediaInfoModule', 'customSentimentRouter', 'customSentimentServiceModule', 'keyWordsModule'])
    .controller('customSentimentCtrl', ["$scope", "modalDialog", "trsHttpService", "$q", "customSentimentService",
        function($scope, modalDialog, trsHttpService, $q, customSentimentService) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    pathType: 'todaysentiment',
                    emphasisNav: 'criticalfocus',
                    radarDataFlag: 0,
                    radarTips: [
                        '需要关注重点的舆情态势，如果此数据比较大则说明今天有突发事件发生。',
                        '本地舆情在全部舆情中的占比，如果数据大幅上升则说明本地可能出现了可以挖掘的舆情信息内容。',
                        '自定义舆情在全部舆情中的占比，如果数据大幅上升则说明，自定义内容可能出现了可以挖掘的舆情信息内容。',
                        '全部舆情的声量，判断整个大环境的趋势，如果数据大幅度上升说明可能有比较重大的事件发生。',
                        '舆情的正面性，判断整个大环境舆情的正负面信息，如果数据大幅下降怎说明整体舆情的态势。'
                    ],
                    radarDrawFinish: false,
                    radarContainer: null,
                    radarOption: {
                        tooltip: {},
                        color: ['#d64541', '#A4E6B1'],
                        legend: {
                            bottom: 0,
                            itemGap: 60,
                            itemWidth: 10,
                            data: [{
                                name: '今日数据',
                                // 强制设置图形为圆。
                                icon: 'circle',
                                selectedMode: false,
                            }, {
                                name: '平均数据',
                                // 强制设置图形为圆。
                                icon: 'circle',
                                selectedMode: false,
                            }]
                        },
                        radar: {
                            name: {
                                textStyle: {
                                    color: '#2A2A2A',
                                    fontSize: 14
                                }
                            },
                            indicator: []
                        },
                        series: [{
                            name: '',
                            type: 'radar',
                            data: [{
                                    value: [],
                                    name: '今日数据',
                                    lineStyle: {
                                        width: 2.5
                                    },
                                    itemStyle: {
                                        borderWidth: 4,
                                        color: '#d64541'
                                    }
                                },
                                {
                                    value: [],
                                    name: '平均数据',
                                    lineStyle: {
                                        width: 2.5
                                    },
                                    itemStyle: {
                                        borderWidth: 4,
                                        color: '#A4E6B1'
                                    }
                                }
                            ]
                        }]
                    }

                };
                $scope.data = {
                    emphasisData: [],
                    customTabArr: [],
                    customData: [],
                    mediaInfoTabArr: [],
                    mediaInfoData: [],
                };
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                getEmphasisSentimentData();
                getCustomTab().then(function() {
                    getCustomData();
                });
                getMediaInfoTab().then(function() {
                    getMediaInfoData();
                });
                getRadarData().then(function() {
                    return drawRadar();
                }).then(function() {
                    $scope.status.radarDrawFinish = true;
                });
            }
            /**
             * [getRadarData description] 获取雷达图数据
             * @return {[type]} [description]
             */
            function getRadarData() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'radar',
                    'serviceid': 'customsentiment'
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.status.radarOption.radar.indicator = [
                            { name: '突发舆情', max: getMax(data.BREAKRADAR) * 1.1 },
                            { name: '属地声量', max: getMax(data.AREARADAR) * 1.1, nameGap: 20 },
                            { name: '自定义声量', max: getMax(data.CUSTOMRADAR) * 1.1 },
                            { name: '综合声量', max: getMax(data.GENERALRADAR) * 1.1 },
                            { name: '正面宣传', max: getMax(data.POSITIVERADAR) * 1.1 },
                        ];
                        $scope.status.radarOption.series[0].data[0].value = arrFormat(data, 'TODAYNUM');
                        $scope.status.radarOption.series[0].data[1].value = arrFormat(data, 'AVERAGENUM');
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [drawRadar description] 雷达图绘制
             * @return {[type]} [description]
             */
            function drawRadar() {
                var defer = $q.defer();
                require(['./lib/echarts/dist/echarts.min.js'], function(echarts) {
                    $scope.status.radarContainer = echarts.init(document.getElementById('radarChart'));
                    $scope.status.radarContainer.setOption($scope.status.radarOption);
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getMax description] 获取雷达图数据最大值
             * @param  {[type]} obj [description]
             * @return {[type]}     [description]
             */
            function getMax(obj) {
                var maxVal = 0;
                if (angular.isDefined(obj)) {
                    if (obj.TODAYNUM > obj.AVERAGENUM) {
                        maxVal = obj.TODAYNUM;
                    } else {
                        maxVal = obj.AVERAGENUM;
                    }
                }
                return maxVal;
            }
            /**
             * [arrFormat description] 雷达图数组格式化
             * @param  {[type]} property [description]
             * @return {[type]}          [description]
             */
            function arrFormat(data, property) {
                var arr = [];
                angular.isDefined(data.BREAKRADAR) ? arr.push(data.BREAKRADAR[property]) : arr.push(0);
                angular.isDefined(data.AREARADAR) ? arr.push(data.AREARADAR[property]) : arr.push(0);
                angular.isDefined(data.CUSTOMRADAR) ? arr.push(data.CUSTOMRADAR[property]) : arr.push(0);
                angular.isDefined(data.GENERALRADAR) ? arr.push(data.GENERALRADAR[property]) : arr.push(0);
                angular.isDefined(data.POSITIVERADAR) ? arr.push(data.POSITIVERADAR[property]) : arr.push(0);
                return arr;
            }
            /**
             * [getEmphasisSentimentData description] 获取重点舆情数据
             * @return {[type]} [description]
             */
            function getEmphasisSentimentData() {
                var defer = $q.defer();
                var params = {
                    'modelid': $scope.status.emphasisNav == 'criticalfocus' ? 'keysentiments' : 'breaksentiments',
                    'serviceid': 'customsentiment',
                    'page_no': 0,
                    'page_size': 5,
                    'flag': 1
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.emphasisData = data.PAGEITEMS;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [getCustomTab description] 获取自定义舆情tab数据
             * @return {[type]} [description]
             */
            function getCustomTab() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'customtitles',
                    'serviceid': 'customsentiment'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.customTabArr = data;
                        $scope.status.customNav = data.length == 0 ? '' : data[0].id;
                        defer.resolve(data);
                    });
                return defer.promise;
            }

            function getCustomData() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'customsentiments',
                    'serviceid': 'customsentiment',
                    'id': $scope.status.customNav,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.customData = data.PAGEITEMS;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [getMediaInfoTab description] 获取社交媒体信息tab数据
             * @return {[type]} [description]
             */
            function getMediaInfoTab() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'metanavigation',
                    'serviceid': 'customsentiment'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.mediaInfoTabArr = data;
                        $scope.status.mediaInfoNav = (data == '{}' || data.length == 0) ? '' : data[0].type;
                        defer.resolve(data);
                    });
                return defer.promise;
            }

            function getMediaInfoData() {
                var defer = $q.defer();
                var params = {
                    'modelid': 'metasearch',
                    'serviceid': 'customsentiment',
                    'type': $scope.status.mediaInfoNav
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        if (data.code == 0) {
                            $scope.status.mediaNoKeywords = true;
                        } else {
                            $scope.status.mediaNoKeywords = false;
                        }
                        $scope.data.mediaInfoData = data.data;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [selectNav description] tab切换
             * @param  {[type]} property [description] 切换属性
             * @param  {[type]} nav      [description] 选中的nav
             * @return {[type]}          [description]
             */
            $scope.selectNav = function(property, nav) {
                if ($scope.status[property] == nav) {
                    return;
                } else {
                    $scope.status[property] = nav;
                }
                if (property == 'emphasisNav') {
                    getEmphasisSentimentData();
                } else if (property == 'customNav') {
                    getCustomData();
                } else if (property == 'mediaInfoNav') {
                    getMediaInfoData();
                }
            }
            /**
             * [settingSentiment description] 设置弹窗
             * @param  {[type]} nav [description] 选中的tab导航
             * @return {[type]}     [description]
             */
            $scope.settingSentiment = function(nav) {
                var tabSelected = angular.isDefined(nav) ? nav : '';
                customSentimentService.settingSentiment(tabSelected, function(result) {
                    initData();
                });
            }
            /**
             * [ImgInit description] 社交媒体信息图片路径信息初始化
             * @param {[type]} item [description]社交媒体信息元
             */
            $scope.ImgInit = function(item) {
                if (item.picUrl != null) {
                    if (item.picUrl[item.picUrl.length - 1] == ';') {
                        item.picUrl = item.picUrl.substr(0, item.picUrl.length - 1);
                    }
                    item.imgArr = item.picUrl.split(';');
                } else {
                    item.imgArr = [];
                }

            }
        }
    ]);